import React, { useEffect, useRef, useState } from 'react';

const LabelOverlay = ({ scatterplot, fontSize = 12 }) => {
    const canvasRef = useRef(null);
    const [opacity, setOpacity] = useState(0);

    const defaultLabels = [
        { position: [-0.6, 0.4], text: "Host-associated" },
        { position: [0.1, -0.6], text: "Soil / Freshwater" },
        { position: [0.7, 0.3], text: "Marine" }
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpacity(1);
        }, 2000);

        return () => {
            clearTimeout(timer);
            setOpacity(0);
        };
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || !scatterplot) return;

        const updateOverlay = () => {
            const ctx = canvas.getContext('2d');
            const dpr = window.devicePixelRatio;

            const { width, height } = canvas.getBoundingClientRect();

            canvas.width = width * dpr;
            canvas.height = height * dpr;
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.font = `${fontSize * dpr * 2}px sans-serif`;
            ctx.textAlign = 'center';
            ctx.strokeStyle = 'black';
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 15;

            const xScale = scatterplot.get('xScale');
            const yScale = scatterplot.get('yScale');

            defaultLabels.forEach(({ position, text }) => {
                const textSize = ctx.measureText(text);
                // console.log('textSize:', textSize);
                const boxSizeX = textSize.width + 25;
                const boxSizeY = (textSize.actualBoundingBoxAscent + 12) + (textSize.actualBoundingBoxDescent + 12);
                const screenX = xScale(position[0]) * dpr;
                const screenY = yScale(position[1]) * dpr;
                ctx.globalAlpha = opacity;

                ctx.beginPath();
                ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
                ctx.rect(screenX - (boxSizeX / 2), screenY - boxSizeY, boxSizeX, boxSizeY);
                ctx.fill();

                ctx.fillStyle = 'rgb(255, 255, 255)';
                // ctx.fillText(text, screenX, screenY - (fontSize * 1.2 * dpr));
                ctx.fillText(text, screenX, screenY - (fontSize * 0.8 * dpr));
            });
        };

        updateOverlay();

        const drawingSubscription = scatterplot.subscribe('drawing', updateOverlay);

        const handleResize = () => {
            const { width, height } = canvas.parentElement.getBoundingClientRect();
            canvas.style.width = `100%`;
            canvas.style.height = `100%`;
            updateOverlay();
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [scatterplot, fontSize, opacity]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -1,
                transition: 'opacity 0.5s ease-in-out',
                opacity: opacity
            }}
        />
    );
};

export default LabelOverlay;